export default 'fonts/8a17ea540a94e2d95588f4621e96edd1.eot';